import { useState } from "react"
import { IUser } from "../../types"
import UserContext from "./UserContext";

const UserProvider = ({ children }: { children: JSX.Element }) => {

    const [user, setUser] = useState<IUser>(null!);
    const [roles, setRoles] = useState<any>([]);
    
    return (
        <UserContext.Provider value={{ user, setUser, roles, setRoles }}>
            {children}
        </UserContext.Provider>
    )

}

export default UserProvider;